import { useRef } from "react";
import { useInView, useReducedMotion, motion as m } from "framer-motion";

const FadeUp = ({ children, delay = 0 }) => {
  const containerRef = useRef(null);
  // Trigger once a small part of the element is visible (was 0.6), so tall
  // sections are not left faded while partly on screen.
  const containerInView = useInView(containerRef, { amount: 0.15, once: true });

  // Skip the reveal and render content visible when the visitor prefers reduced
  // motion, or when an automated agent is driving the page (crawlers, headless
  // browsers, screenshot tools). Otherwise content sits at opacity 0 until
  // scrolled into view, which reads as broken to anyone whose animations do not
  // run and hides it from any tool that does not scroll.
  const reduceMotion = useReducedMotion();
  const isAutomated =
    typeof navigator !== "undefined" && navigator.webdriver === true;
  const noIntersectionObserver = typeof IntersectionObserver === "undefined";
  const noAnimation = reduceMotion || isAutomated || noIntersectionObserver;
  const visible = noAnimation || containerInView;

  return (
    <m.span
      ref={containerRef}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(24px)",
        transitionDuration: noAnimation ? "0s" : "0.3s",
        transitionDelay: visible && !noAnimation ? `${delay}s` : "0s",
        height: "fit-content",
        display: "block"
      }}
    >
      {children}
    </m.span>
  );
};

export default FadeUp;
